import { get } from "lodash";

import { truck } from "../../constants/common";

import {
  INITIATE,
  INITIATE_ZONE,
  CLEAR_ZONE_EVENTS,
  SET_TIMEOUT,
  ADD_EVENT,
  OPEN_CARD,
  SET_OPEN,
  ADD_DAC_DETAILS,
  UPDATE_EVENTS,
} from "../../constants/actionTypes";
import { absent, identified, unidentified } from "../../constants/common";
import { driveInOut, walkInOut } from "../../constants/reducers";

import { getLatestLog } from "./tabs";

export const initiate = (name, defaultTimer) => ({
  type: INITIATE,
  name,
  defaultTimer,
});

export const initiateZone = (name, zoneId) => ({
  type: INITIATE_ZONE,
  name,
  zoneId,
});

export const clearZoneEvents = (name, zoneId, sessionId) => ({
  type: CLEAR_ZONE_EVENTS,
  name,
  zoneId,
  sessionId,
});

export const startTimeout = (name, zoneId, timeout, sessionId) => ({
  type: SET_TIMEOUT,
  name,
  zoneId,
  timeout,
  sessionId,
});

export const addDacDetails = (name, zoneId, sessionId, dacEventGroup) => ({
  type: ADD_DAC_DETAILS,
  name,
  zoneId,
  sessionId,
  dacEventGroup,
});

export const addEvent = (name, zoneId, eventType, newEvent) => {
  return (dispatch, getState) => {
    if (
      newEvent.type === truck &&
      newEvent.state !== absent &&
      getState().siteEntranceExit[name].liveEvents[zoneId] &&
      [identified, unidentified].includes(
        get(getState(), [
          "siteEntranceExit",
          name,
          "liveEvents",
          zoneId,
          truck,
          "state",
        ])
      )
    ) {
      dispatch(getLatestLog(name, zoneId));
    }
    dispatch({
      type: ADD_EVENT,
      name,
      zoneId,
      eventType,
      newEvent,
    });
  };
};

export const openCard = (name, zoneId, sessionId) => {
  return (dispatch, getState) => {
    let card;
    if (name === walkInOut) {
      card = get(getState(), [
        "siteEntranceExit",
        name,
        "liveEvents",
        zoneId,
        "events",
        sessionId,
      ]);
    } else if (name === driveInOut) {
      card = get(getState(), ["siteEntranceExit", name, "liveEvents", zoneId]);
    }
    if (get(card, ["timeout"])) {
      clearTimeout(get(card, ["timeout"]));
    }
    dispatch({
      type: OPEN_CARD,
      name,
      zoneId,
      sessionId,
    });
  };
};

export const setOpen = (name, zoneId, sessionId, open) => ({
  type: SET_OPEN,
  name,
  zoneId,
  sessionId,
  open,
});

export const updateLiveEvents = (name, zoneId, events) => ({
  type: UPDATE_EVENTS,
  name,
  zoneId,
  payload: events,
});
